<mat-card appearance="outlined">
  <mat-card-title class="tw-flex tw-items-center">
    <ui-svg-icon [name]="iconNameList.DocumentAdd" [width]="32"></ui-svg-icon>
    <span>{{ 'waybill.foreignTrade.documentPending.title' | translate }}</span>
  </mat-card-title>
  <mat-table [dataSource]="documents" noDataTableMessage multiTemplateDataRows>
    <ng-container matColumnDef="arrivalDate">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.arrivalDate' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.arrivalDate | date | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="clearanceDate">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.clearanceDate' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.clearanceDate | date | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="deviationDescription">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.deviationDescription' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.deviationDescription | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="beginDate">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.beginDate' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.beginDate | date | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="endDate">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.endDate' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.endDate | date | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="observation">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.observation' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.observation | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="justification">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.justification' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.justification | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="aimedBy">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.aimedBy' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.aimedBy | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="concludedBy">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.concludedBy' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.concludedBy | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="conclusionEntity">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.conclusionEntity' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.conclusionEntity | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="invoice">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.invoice' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.invoice | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="materialDeviation">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.foreignTrade.documentPending.th.materialDeviation' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span class="break-anywhere">
          {{ element.materialDeviation | nullToNotAvailable }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="deviationOrderItem">
      <mat-header-cell *matHeaderCellDef class="deviation-order-column">
        {{ 'waybill.foreignTrade.documentPending.th.deviationOrderItem' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="deviation-order-column">
        <span class="break-anywhere">
          {{ element.deviationOrderItem | nullToNotAvailable }}
        </span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columns"></mat-row>
  </mat-table>
</mat-card>

<ng-template #notAvailableTemplate>
  {{ notAvailable }}
</ng-template>
